import { createTheme } from '@mui/material';

const BLUE_100 = '#4dabf5';
const BLUE_200 = '#2196f3';
const BLUE_300 = '#1769aa';

const GRAY_100 = '#f5f5f5';
const GRAY_200 = 'rgba(0, 0, 0, 0.54)';
const GRAY_300 = 'rgba(0, 0, 0, 0.38)';

const defaultTheme = createTheme();

export default createTheme(defaultTheme, {
	palette: {
		primary: {
			main: BLUE_200,
			light: BLUE_100,
			dark: BLUE_300,
		},
		background: {
			default: GRAY_100,
		},
		action: {
			disabled: GRAY_300,
			active: GRAY_200,
		},
	},
	components: {
		MuiDialogActions: {
			styleOverrides: {
				spacing: {
					padding: '0.5rem 1.5rem 1.5rem',
				},
			},
		},
		MuiDialogContent: {
			styleOverrides: {
				root: {
					padding: '0 1.5rem 1.25rem',
				},
			},
		},
	},
});
